var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLibrary = function SvgLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    d: "M5.282 7.85v8.3M8.099 7.85v8.3M10.916 7.85v8.3M12.881 8.066l6.699 7.817"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 22.4,
    x: 0.8,
    y: 0.8,
    stroke: "#292D32",
    strokeWidth: 1.6,
    rx: 5.2
  })));
};
export default SvgLibrary;